import React from "react";
import { Container, StyledInput } from "./styles";
import { Label } from "../CustomTextArea/styles";
import { Button } from "antd";

export interface InputProps {
  name: string;
  placeholder: string;
  type?: string;
  value?: string;
  withTitle?: boolean;
  disabled?:boolean;

  onChange: (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => void;
}

const Input = ({ name, placeholder, onChange,withTitle,type,value,disabled}: InputProps) => {

  return (
    <Container>
      {withTitle && (
        <Label htmlFor={name}>{name}</Label>
      )}   
      <StyledInput
        type = {type}
        placeholder={placeholder}
        name={name}
        id={name}
        onChange={onChange}
        disabled={disabled}
        defaultValue={value}
      />
    </Container>
  )

};

export default Input;
